export const NAVBAR_ACTIONS = {
  //Get Bible Aids
  NAVBAR_ON: "NAVBAR_ON",
  NAVBAR_OFF: "NAVBAR_OFF",

  KEBAB_ON: "KEBAB_ON",
  KEBAB_OFF: "KEBAB_OFF"
};
